import { useState } from "react";
import { Button } from "../ui/Button";

interface BrandCorpusProps {
  onAdd: (content: string) => void;
  adding?: boolean;
}

export function BrandCorpus({ onAdd, adding }: BrandCorpusProps) {
  const [content, setContent] = useState("");

  function handleAdd() {
    if (content.trim()) {
      onAdd(content.trim());
      setContent("");
    }
  }

  return (
    <div className="space-y-4">
      <p className="text-sm text-slate-500">
        Add reference content so the AI can learn your brand's style. Paste blog posts,
        social media content, marketing copy, or any text that represents your voice.
      </p>
      <textarea
        value={content}
        onChange={(e) => setContent(e.target.value)}
        placeholder="Paste reference content here..."
        className="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm placeholder:text-slate-400 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500"
        rows={6}
      />
      <Button onClick={handleAdd} disabled={adding || !content.trim()}>
        {adding ? "Adding..." : "Add to corpus"}
      </Button>
    </div>
  );
}
